import { defineComponent as _defineComponent } from 'vue'
import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, vModelText as _vModelText, Fragment as _Fragment, renderList as _renderList, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "radio-group"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "description" }
const _hoisted_4 = { class: "row mt-4" }
const _hoisted_5 = { class: "col-12 mt-2" }
const _hoisted_6 = {
  key: 0,
  class: "your-choice border-start border-success border-5 bg-light rounded-3 p-4 shadow-sm"
}
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { class: "fw-medium fst-italic" }
const _hoisted_9 = { class: "d-flex flex-wrap align-items-center" }
const _hoisted_10 = { class: "me-4" }
const _hoisted_11 = {
  class: "fw-bold",
  style: {"display":"inline-block","width":"2ch","text-align":"right"}
}
const _hoisted_12 = { class: "d-flex flex-grow-1 align-items-center mt-2 mt-sm-0" }
const _hoisted_13 = ["max"]
const _hoisted_14 = { class: "ms-3" }
const _hoisted_15 = {
  key: 1,
  class: "your-choice border-start border-success border-5 bg-light rounded-3 p-4 shadow-sm"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }

import { computed, ref, watch } from "vue";
    import { formatter } from "@/shared/ts/formatter";
    import TaxFreeCashModelSupporter from "@/guiide/ts/assets/finalsalary/taxFreeCashModelSupporter";
    import FinalSalaryScheme from "@/guiide/ts/assets/finalsalary/finalSalaryScheme";
    import type { NextStepsOptions } from '@/guiide/ts/dbOptions/nextStepsOptions';
    import NextStepCoaching from "./NextStepCoaching.vue";
    import NextStepIFA from "./NextStepIFA.vue";
    import { useUIContent } from "@/guiide/ts/configuration/useUIContent";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'NextSteps',
  props: {
        scheme: { type: Object as () => FinalSalaryScheme, required: true },
        taxFreeCashModelSupporter: { type: TaxFreeCashModelSupporter, required: true },
        selectedOptionName: { type: String, required: true },
        immediateSpendModel: { type: Number, required: true },
        selectedOptionStartingPension: { type: Number, required: true }
    },
  emits: ["update-selected-next-steps-option", "update:immediateSpendModel"],
  setup(__props, { emit: __emit }) {

    const selectedNextStepsOption = ref<NextStepsOptions>('buildPlan');

    const props = __props;

    const { text, textArray } = useUIContent();

    const schemeSupportMode = props.scheme.supportMode;

    const emit = __emit;

    watch(selectedNextStepsOption, (newValue: NextStepsOptions) => {
        emit("update-selected-next-steps-option", newValue)
    }, { immediate: true });

    const hasSupportOptions = computed<boolean>(() => props.scheme.supportMode != "None");

    const localImmediateSpendModel = computed({
        get: () => props.immediateSpendModel,
        set: (value) => emit("update:immediateSpendModel", value)
    });

    const isTakingTaxFreeCash = computed<boolean>(() => props.taxFreeCashModelSupporter.activeActual > 0);

    const planChoicesText = computed(() => {
        const taxFreeCash = props.taxFreeCashModelSupporter.activeActual;
        const startingPension = ` - a starting pension of ${formatter.formatCurrency(props.selectedOptionStartingPension)}`;
        const taxFreeCashInfo = isTakingTaxFreeCash.value ? ` and a tax free cash lump sum of ${formatter.formatCurrency(taxFreeCash)}` : '';
        return props.selectedOptionName + startingPension + taxFreeCashInfo + '.';
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (hasSupportOptions.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("label", {
            class: _normalizeClass(["radio-option rounded-start", {'active': selectedNextStepsOption.value == 'buildPlan'}]),
            "data-value": "buildPlan"
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              value: "buildPlan",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedNextStepsOption).value = $event))
            }, null, 512), [
              [_vModelRadio, selectedNextStepsOption.value]
            ]),
            _createElementVNode("div", _hoisted_2, [
              _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-tools" }, null, -1)),
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "fw-bold" }, "I want to build a retirement plan", -1)),
              _createElementVNode("p", _hoisted_3, "Click here to explore how your " + _toDisplayString(__props.scheme.name) + " fits into your retirement plan.", 1)
            ])
          ], 2),
          _createElementVNode("label", {
            class: _normalizeClass(["radio-option rounded-end", {'active': selectedNextStepsOption.value == 'getSupport'}]),
            "data-value": "getSupport"
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              value: "getSupport",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedNextStepsOption).value = $event))
            }, null, 512), [
              [_vModelRadio, selectedNextStepsOption.value]
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "content" }, [
              _createElementVNode("i", { class: "bi bi-chat-right-text" }),
              _createElementVNode("p", { class: "fw-bold" }, "I need support with my options"),
              _createElementVNode("p", { class: "description" }, "Click here to view details of how you can get support with your options.")
            ], -1))
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (selectedNextStepsOption.value === 'buildPlan')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[9] || (_cache[9] = _createElementVNode("h4", { class: "mb-3" }, "Build a retirement plan", -1)),
              _cache[10] || (_cache[10] = _createElementVNode("p", null, "The following option from the section above will be used to build your retirement plan in the rest of this tool:", -1)),
              _createElementVNode("p", _hoisted_7, _toDisplayString(planChoicesText.value), 1),
              (isTakingTaxFreeCash.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "mt-4 pb-2 mx-5" }, null, -1)),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(text)('dboptions.next-steps.tfc-spend-immediate.question')), 1),
                    _createElementVNode("p", null, _toDisplayString(_unref(text)('dboptions.next-steps.tfc-spend-immediate.advice')), 1),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, [
                        _cache[6] || (_cache[6] = _createTextVNode(" Immediate spend of tax free cash: ")),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(formatter).formatCurrency(localImmediateSpendModel.value)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "ms-sm-4 me-3" }, "0", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "range",
                          class: "form-range my-2 flex-grow-1",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localImmediateSpendModel).value = $event)),
                          min: "0",
                          max: __props.taxFreeCashModelSupporter.activeActual,
                          step: "100"
                        }, null, 8, _hoisted_13), [
                          [
                            _vModelText,
                            localImmediateSpendModel.value,
                            void 0,
                            { number: true }
                          ]
                        ]),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(formatter).formatCurrency(__props.taxFreeCashModelSupporter.activeActual)), 1)
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _cache[11] || (_cache[11] = _createElementVNode("hr", { class: "mt-4 mb-4 mx-5" }, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(textArray)('dboptions.next-steps.conclusion'), (p, i) => {
                return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(p), 1))
              }), 128)),
              _cache[12] || (_cache[12] = _createElementVNode("small", { class: "mt-4 fst-italic text-muted small" }, " Disclaimer: You should always seek appropriate professional advice and satisfy yourself that any action you take in connection with information and calculations provided by this website is suitable for your particular circumstances. ", -1))
            ]))
          : (selectedNextStepsOption.value === 'getSupport')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (_unref(schemeSupportMode) === 'Coaching')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createVNode(NextStepCoaching)
                    ]))
                  : (_unref(schemeSupportMode) === 'IFA')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(NextStepIFA)
                      ]))
                    : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})